import { EndsStepModel } from "../../wizard/steps/1-ends/ends-step.model";
import { TranspondersStepModel } from "../../wizard/steps/2-transponders/transponders-step.model";
import { IntermediatesStepModel } from "../../wizard/steps/3-intermediates/intermediates-step.model";
import { LinksStepModel } from "../../wizard/steps/4-links/links-step.model";
import { AmplifiersStepModel } from "../../wizard/steps/5-amplifiers/amplifiers-step.model";
import { OscManagementStepModel } from "../../wizard/steps/6-osc-management/osc-management-step.model";
import { DwdmDiagramConverterModelsBuilder } from "./dwdm-diagram-converter-models-builder";
import { CircuitConvertedDataToDiagram, CircuitToDiagramData } from "./dwdm-diagram-converter.models";

/**
 * Classe abstrata responsável por converter os modelos das telas para o modelo do diagrama.
 *
 * Essa classe contém todos os comportamentos comuns entre todas as janelas.
 * Comportamentos específicos da tela de Diagnósticos ou da Wizard de criação devem ser
 * implementados nas classes concretas.
 */
export abstract class DwdmDiagramAbstractConverter {

    private readonly converterModelsBuilder: DwdmDiagramConverterModelsBuilder;

    constructor() {
        this.converterModelsBuilder = new DwdmDiagramConverterModelsBuilder();
    }

    convertModels(circuitToDiagramData: CircuitToDiagramData): CircuitConvertedDataToDiagram {
        const isOnOscStep = circuitToDiagramData.isOnOscStep;
        const isOnLinkStep = circuitToDiagramData.isOnLinkStep;
        const stepModel = circuitToDiagramData.circuitModels;
        const endsModel = stepModel["EndsStepModel"] as EndsStepModel;
        const transpondersModel = stepModel["TranspondersStepModel"] as TranspondersStepModel;
        const intermediatesModel = stepModel["IntermediatesStepModel"] as IntermediatesStepModel;
        const linksModel = stepModel["LinksStepModel"] as LinksStepModel;
        const amplifiersModel = stepModel["AmplifiersStepModel"] as AmplifiersStepModel;
        const oscsData = stepModel["OscManagementStepModel"] as OscManagementStepModel;

        const aEndData = this.converterModelsBuilder.buildAEndConverterData(
            endsModel, transpondersModel, intermediatesModel, linksModel, amplifiersModel, oscsData, isOnOscStep);
        const zEndData = this.converterModelsBuilder.buildZEndConverterData(
            endsModel, transpondersModel, intermediatesModel, linksModel, amplifiersModel, oscsData, isOnOscStep);
        const intermediatesData = this.converterModelsBuilder.buildIntermediatesConverterData(
            intermediatesModel, linksModel, amplifiersModel, endsModel, oscsData, isOnOscStep);
        const linksData = this.converterModelsBuilder.buildLinksConverterData(linksModel, isOnLinkStep);

        return {
            aEnd: aEndData,
            zEnd: zEndData,
            intermediates: intermediatesData,
            links: linksData
        };
    }
}
